





































import {Vue, Component} from 'vue-property-decorator'
import {formatDate} from "@/utils/formatters";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({name: 'komentari'})
export default class Komentari extends mixins(ComponentBaseMixin) {
  enableDates = true;
  commentTypes = [];
  commentType = '';

  comments = [];
  columns = [];
  tableOptions = {
    search: true,
    pagination: true,
    rowStyle: this.rowStyle,
    onClickRow: row => this.onClickRow(row)
  };
  isBusySearch = false;

  async created() {
    this.columns = [
      {field: 'date', title: this.$i18n.t('datum'), formatter: formatDate},
      {field: 'storeName', title: this.$i18n.t('objekat')},
      {field: 'address', title: this.$i18n.t('adresa')},
      {field: 'city', title: this.$i18n.t('mesto')},
      {field: 'user', title: this.$i18n.t('merchandiser')},
      {field: 'comment', title: this.$i18n.t('komentari')},
    ];
    const {data} = await this.axios.get('api/visit/commentTypes');
    this.commentTypes = data;
  }

  mounted() {
    let picker = $('#daterange');
    picker.daterangepicker(
        {
          format: this.$i18n.t('DATE_FORMAT'),
          autoApply: true
        },
    ).data('daterangepicker').setStartDate(new Date());
  }

  async search() {
    this.comments = [];
    let picker = $('#daterange');
    let fromDate = this.enableDates ? picker.data('daterangepicker').startDate.format('YYYY-MM-DD') : '';
    let toDate = this.enableDates ? picker.data('daterangepicker').endDate.format('YYYY-MM-DD') : '';
    let table = $('#commentsTable');
    table.bootstrapTable('showLoading');
    this.isBusySearch = true;
    await this.axios.get('api/visit/comments', {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        commentType: this.commentType || ''
      }
    }).then((result) => {
      this.comments = result.data;
    }).catch(err => {
      table.bootstrapTable('hideLoading');
      this.isBusySearch = false;
      this.showError('greskaPrilikomUcitavanja');
    }).finally(() => {
      table.bootstrapTable('hideLoading');
      this.isBusySearch = false;
    });
  }

  rowStyle(row) {
    if (row.alarm) {
      return { css : {'color': 'red'} }
    } else {
      return {}
    }
  }

  onClickRow(row) {
    this.$router.push({name: 'poseta', params: {publicVisitID: row.publicVisitID}})
  }
}
